import { BaseService } from "./baseService";

export interface Testimonial<DateType = string>
{
    author: string;
    authorImage: string | null;
    /**
     * Brand mark shown beside the name, as the design draws it. The CMS has no
     * such field yet — the collection lives in the Payload backend, not this
     * repo — so Testimonials.tsx falls back to a local map keyed by
     * authorImage. Once the field exists this is used without further change.
     */
    brandLogo?: string | null;
    createdAt: DateType;
    description: string;
    id: string;
    title: string;
    updatedAt: Date;
}

export class TestimonialService extends BaseService
{
    public static async get(): Promise<Testimonial[]>
    {
        const response = await this.getData<Testimonial[]>('/testimonials?where%5BisVisible%5D[equals]=true');
        return response;
    }
}
